module.exports = __webpack_public_path__ + "img/rework.226c46f2.jpg";